@let _serverError = errorMessage | async;
@let _passwordError = passwordError | async;
@let _confirmError = confirmPasswordError();

<ada-card [fullscreenEnabled]="false">
	<ada-text
		content="Reset Password"
		data-container-selector="ada-card-header"
	/>
	<ada-container
		data-container-selector="ada-card-body"
		verticalSpacing="Small"
	>
		@if (_serverError) {
			<ada-alert
				data-testid="error-alert"
				type="Error"
				[details]="_serverError"
				[isClosable]="false"
			/>
		}

		<ada-text
			content="Login Email"
			textColor="primary"
		/>
		<ada-input
			data-testid="email-input"
			placeholder="Email address"
			type="Email"
			[showAsFullWidth]="true"
			[(value)]="userEmail"
		/>
		<ada-text
			content="Password"
			textColor="primary"
		/>
		<ada-input
			data-testid="password-input"
			placeholder="New password"
			type="Password"
			[showAsFullWidth]="true"
			[(value)]="userPassword"
			(valueChange)="checkPasswordError($event)"
		/>
		@if (_passwordError) {
			<ada-text
				content="* {{ _passwordError }}"
				textColor="accent"
				[colSpan]="4"
				[fontSize]="ui.FontSize.FONT_SIZE_SMALL"
			/>
		}
		<ada-text
			content="Confirm Password"
			textColor="primary"
		/>
		<ada-input
			data-testid="confirm-password-input"
			placeholder="Confirm new password"
			type="Password"
			[showAsFullWidth]="true"
			[(value)]="userConfirmPassword"
			(valueChange)="checkPasswordMatch()"
		/>
		@if (_confirmError) {
			<ada-text
				content="* {{ _confirmError }}"
				textColor="accent"
				[colSpan]="4"
				[fontSize]="ui.FontSize.FONT_SIZE_SMALL"
			/>
		}
	</ada-container>
	<ada-push-button
		#ResetButton
		data-container-selector="ada-card-footer"
		data-testid="login-button"
		text="Reset"
		[adaClick]="reset | adaBindMethod: this"
		[isDisabled]="!userPassword || !userConfirmPassword || _passwordError || _confirmError"
		[showAsFullWidth]="true"
	/>
</ada-card>
